<main class="dialog">
    <header class="dialog-header">
        <h2 class="dialog-title">Confirmar</h2>
    </header>
    <section class="main-message">
        <p>Serão realizada(s) a(s) seguinte(s) alterações:</p>
        <ul>
            <li *ngFor="let change of changeList">{{change}}</li>
        </ul>
        <p *ngIf="warning" class="warning"><b>Atenção: </b>{{warning}}</p>
        <p class="margin">Deseja que estas alterações sejam aplicadas às empresas listadas?</p>
    </section>
    <mat-dialog-actions class="buttons-dialog">
        <div class="button-container -flexEnd">
            <button mat-dialog-close class="o-button -white">Voltar</button>
            <button class="o-button -blue" (click)=acceptChange()>Confirmar Alteração</button>
        </div>
    </mat-dialog-actions>
</main>
